




















































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import Location from '@/services/Location';
import LocationService from '@/services/LocationService';
import { KSpinner } from '@kasasa/fbase-components';
import LocationListFilter from '@/components/LocationListFilter/LocationListFilter.vue';

const reverseSort = (a: number, b: number) => (a > b ? -1 : 1);

interface Filter {
	state: string[];
	city: string;
	enabled: string;
	locationTypes: Array<number>;
}

@Component({
	components: {
		KSpinner,
		LocationListFilter
	}
})
export default class LocationListTable extends Vue {
	@Prop({ default: () => [] }) readonly locations!: Location[];
	@Prop({ default: false}) readonly isLoaded!: boolean;

	filter: Filter = {
		state: [],
		city: '',
		enabled: '',
		locationTypes: []
	}

	headers: DataTableHeader[] = [
		{ text: 'Location Name',   value: 'title',    width: '190px' },
		{ text: 'Address',         value: 'address1',    width: '310px' },
		{ text: 'City',         value: 'city',    width: '180px' },
		{ text: 'State',         value: 'state',    width: '90px' },
		{ text: 'Location Type', value: 'type',    width: '190px' },
		{ text: 'Location Status', value: 'enabled', width: '140px', sort: reverseSort }, // reverse sort so 1 (Active) is ascending
	];

	locationSvc = new LocationService(this.$store);

	search = '';
	page = 1;
	
	useFilter = false;
	filterStatus = {
		All:      'All',
		Active:   'Active',
		Inactive: 'Inactive'
	}
	currentFilterStatus = this.filterStatus.All;

	get displayLocations() {
		let filteredLocations = this.locations;

		if(this.useFilter){
			filteredLocations = filteredLocations.filter((loc: Location) => {
				return (!this.filter.locationTypes.length || (this.filter.locationTypes.includes(3) && loc.isBrick && loc.hasAtm) ||
					(this.filter.locationTypes.includes(2) && loc.isBrick && !loc.hasAtm) ||
					(this.filter.locationTypes.includes(1) && loc.hasAtm && !loc.isBrick)) &&
					(!this.filter.state.length || (loc.state && this.filter.state.includes(loc.state))) &&
					(!this.filter.city || this.filter.city == loc.city) &&
					(this.filter.enabled === '' || this.filter.enabled === 'all' || (this.filter.enabled === 'active' && loc.enabled) || (this.filter.enabled === 'inactive' && !loc.enabled))
			})
		}

		return filteredLocations;
	}

	resetFilter() {
		this.currentFilterStatus = this.filterStatus.All;
	}
	
	customFilter(index: number, search: string, client: Location) {
		this.page = 1;
		search = search.toLowerCase();

		return (client.title && client.title.toLowerCase().indexOf(search) !== -1) ||
			(client.city && client.city.toLowerCase().indexOf(search) !== -1) ||
			(client.address1 && client.address1.toLowerCase().indexOf(search) !== -1);
	}

	searchHighlight(value: string|number) {
		if (!this.search.length || value === null) {
			return value;
		}

		return value.toString().replace(
			RegExp(this.search, 'ig'),
			(matchText) => '<strong style="color: #000;">' + matchText + '</strong>'
		);
	}

	handleClick(item: Location): void {
		if (item && item.id) {
			this.$router.push({ name: 'ViewLocation', params: { clientId: this.$route.params.clientId, id: item.id.toString() } });
		}
	}

	handleFilterChange(): void {
		const filterRef: LocationListFilter = this.$refs.locationListFilterRef as LocationListFilter;
		if (this.useFilter === false) {
			filterRef.reset()
		}
	}

	mounted() {
		this.handleFilterChange();
	}
 
}
